<template>
  <div id="app" @contextmenu="show($event)">
    <el-backtop :bottom="100" :visibility-height="500">
      <div
        style="{
        height: 100%;
        width: 100%;
        border-radius: 10px;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
        z-index:9999;
      }"
      >
        UP
      </div>
    </el-backtop>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    show(event) {
      // 此处可以使用判断条件控制是否需要阻止右键
      event.preventDefault();
    },
  },
  mounted() {
    if (this.isMobile()) {
      console.log("手机端");
      // this.$router.replace("/m_index");
    } else {
      console.log("pc端");
      // this.$router.replace("/pc_index");
    }
  },
};
</script>

<style lang="less">
#app {
  max-width: 1920px;
  min-width: 1200px;
  margin: 0 auto;
}
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
